import {
  MapPin, Home, Sun, Users, Eye, Camera, Ruler, MessageSquare,
  Wand2, Settings, Package, FolderDown, FileText, Clapperboard,
  Thermometer, Wind, Zap, Droplets, Flame, Snowflake, Paintbrush,
  type LucideIcon,
} from "lucide-react";

export const iconRegistry: Record<string, LucideIcon> = {
  "map-pin": MapPin,
  home: Home,
  sun: Sun,
  users: Users,
  eye: Eye,
  camera: Camera,
  ruler: Ruler,
  "message-square": MessageSquare,
  wand2: Wand2,
  settings: Settings,
  package: Package,
  "folder-down": FolderDown,
  "file-text": FileText,
  clapperboard: Clapperboard,
  thermometer: Thermometer,
  wind: Wind,
  zap: Zap,
  droplets: Droplets,
  flame: Flame,
  snowflake: Snowflake,
  paintbrush: Paintbrush,
};

export function getIcon(key: string): LucideIcon | null {
  return iconRegistry[key] || null;
}
